<canvas #canvas [width]="width" [height]="height" [attr.aria-label]="altText" role="img"></canvas>
